// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-button[data-v-7eaf3694]:hover,.hover-button:hover .v-icon[data-v-7eaf3694]{color:#fff!important}", ""]);
// Exports
module.exports = exports;
